import {OrderSalesResponse} from '../types/Products';

export enum AppRoutes {
  LOGIN = 'Login',
  REGISTER_CODE = 'RegisterCode',
  REGISTER_FORM = 'RegisterForm',
  TOKEN_SCREEN = 'TokenScreen',
  VALIDATED_TOKEN = 'ValidatedToken',
  RESEND_TOKEN = 'ResendToken',
  RECOVER_PASSWORD = 'RecoverPassword',
  RECOVERY_SENT = 'RecoverySent',
  RESET_TOKEN = 'ResetToken',
  NEW_PASSWORD = 'NewPassword',
  HOME = 'Home',
  MAIN_TAB_SCREEN = 'MainTabScreen',
  PRODUCT_DETAILS = 'ProductDetails',
  BAG = 'Bag',
  DEBTS = 'Debts',
  PROFILE = 'Profile',
  EQUIPAMENT = 'Equipamentos',
  EXCHANGES = 'Trocas',
  SUPPORT = 'Support',
  REQUEST_EQUIPAMENT = 'RequestEquipament',
  REQUEST_COMPANY = 'RequestCompany',
  ORDER_SENT = 'OrderSent',
  ORDER_SENT_PIX = 'OrderSentPix',
  CAMPAIGNS_DETAILS = 'CampaignsDetails',
  ORDER_EQUIPAMENTS = 'OrderEquipaments',
  ORDERS = 'Meus pedidos',
  ORDER_DETAILS = 'Detalhes do Pedido',
  CANCEL_ORDER = 'Cancelar Pedido',
  EXCHANGE_PRODUCT = 'Trocar Produto',
  NFSIG = 'NFSig',
  CATALOGO = 'Catálogo',
  FAVORITE_PRODUCTS = 'FavoriteProducts',
  NPS = 'NPS',
  SUGGESTED_COMBO = 'SuggestedCombo',
  CHECKOUT = 'Checkout',
  CONTAINERS = 'Containers',
  CONTAINERS_REQUEST = 'ContainersRequest',
  REQUEST_EQUIPMENT_LIST = 'RequestEquipmentList',
  NOTIFICATIONS = 'Notifications',
  DEBTS_PAYMENT = 'DebtsPayment',
  DEBTS_PAYMENT_PIX = 'DebtsPaymentPix',
  MY_CARDS = 'MyCards',
  NEW_CARD = 'NewCard',
  EQUIPMENT_MAINTENANCE_LIST = 'EquipmentMaintenanceList',
  EQUIPMENT_MAINTENANCE = 'EquipmentMaintenance',
  FEATURED_PRODUCTS = 'FeaturedProducts',
  OFFERS = 'OffersScreen',
  CATALOG_BROWSE = 'CatalogBrowseScreen',
  /** PED-13 RN-23 — o menu DEDICADO de pedidos programados. */
  SCHEDULED_ORDER_MENU = 'ScheduledOrderMenu',
  /** PED-13 RN-16 — o carrinho SOMENTE LEITURA de uma proposta. */
  SCHEDULED_ORDER_REVIEW = 'ScheduledOrderReview',
  /** PAG-01 — o PEDIDO A PAGAR: sacola pré-montada pelo vendedor, sem aceite. */
  AVISTA_ORDER_REVIEW = 'AVistaOrderReview',
}

export type RootStackParamList = {
  [AppRoutes.LOGIN]: undefined;
  [AppRoutes.REGISTER_CODE]: undefined;
  [AppRoutes.REGISTER_FORM]: undefined;
  [AppRoutes.TOKEN_SCREEN]: undefined;
  [AppRoutes.VALIDATED_TOKEN]: undefined;
  [AppRoutes.RESEND_TOKEN]: undefined;
  [AppRoutes.RECOVER_PASSWORD]: undefined;
  [AppRoutes.RECOVERY_SENT]: undefined;
  [AppRoutes.RESET_TOKEN]: {user: string};
  [AppRoutes.NEW_PASSWORD]: {user: string; token: string};
  [AppRoutes.HOME]: {companyModal?: boolean; cleanFilters?: boolean, npsVerify?: boolean};
  [AppRoutes.MAIN_TAB_SCREEN]: undefined;
  [AppRoutes.PRODUCT_DETAILS]: {item?: any, 'sku'?: string, fromBag?: boolean};
  [AppRoutes.BAG]?: {
    repeatOrder?: boolean;
    suggestedOrder?: boolean;
  };
  [AppRoutes.DEBTS]: undefined;
  [AppRoutes.PROFILE]: undefined;
  [AppRoutes.EQUIPAMENT]: undefined;
  [AppRoutes.EQUIPMENT_MAINTENANCE_LIST]: undefined;
  [AppRoutes.EQUIPMENT_MAINTENANCE]: undefined;
  [AppRoutes.EXCHANGES]: undefined;
  [AppRoutes.SUPPORT]: undefined;
  [AppRoutes.REQUEST_EQUIPAMENT]: undefined;
  [AppRoutes.ORDER_SENT]: {response: OrderSalesResponse};
  [AppRoutes.CAMPAIGNS_DETAILS]: undefined;
  [AppRoutes.ORDER_EQUIPAMENTS]: undefined;
  [AppRoutes.ORDERS]: undefined;
  [AppRoutes.ORDER_DETAILS]: undefined;
  [AppRoutes.CANCEL_ORDER]: {item?: object; canCancel?: boolean};
  [AppRoutes.EXCHANGE_PRODUCT]: {item?: object; canExchange?: boolean};
  [AppRoutes.NFSIG]: undefined;
  [AppRoutes.CATALOGO]: undefined;
  [AppRoutes.FAVORITE_PRODUCTS]: undefined;
  [AppRoutes.REQUEST_COMPANY]: undefined;
  [AppRoutes.NPS]: undefined;
  [AppRoutes.SUGGESTED_COMBO]: {item?: any};
  [AppRoutes.CHECKOUT]: undefined;
  [AppRoutes.CONTAINERS]: {refresh: boolean};
  [AppRoutes.CONTAINERS_REQUEST]: undefined;
  [AppRoutes.REQUEST_EQUIPMENT_LIST]: {refresh: boolean};
  [AppRoutes.NOTIFICATIONS]: undefined;
  [AppRoutes.DEBTS_PAYMENT]: {items?: object};
  [AppRoutes.DEBTS_PAYMENT_PIX]: {item?: object};
  [AppRoutes.MY_CARDS]: undefined;
  [AppRoutes.NEW_CARD]: {hasCustomer: boolean};
  [AppRoutes.FEATURED_PRODUCTS]: undefined;
  [AppRoutes.OFFERS]: undefined;
  [AppRoutes.SCHEDULED_ORDER_MENU]: undefined;
  // PED-13 RN-20 — o carrinho é do CONJUNTO, não de uma proposta.
  [AppRoutes.SCHEDULED_ORDER_REVIEW]: {setId: string; clientCode?: string};
  [AppRoutes.AVISTA_ORDER_REVIEW]: {setId: string; clientCode?: string};
  [AppRoutes.CATALOG_BROWSE]: { filter?: { categoryIds?: number[]; categoryNames?: string[]; brandNames?: string[]; lockedCategory?: boolean; source?: 'suggested'; title?: string; carouselId?: number; searchQuery?: string } } | undefined;

};
